// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.71717L2 5.9255V21.4999L7.5 19.2326V2.71717Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.5 18.9095L14.5 21.8623V5.09027L9.5 2.13745V18.9095Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5 4.76719V21.2826L22 18.0742V2.49987L16.5 4.76719Z"}}]};

const MapFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-filled',
    ref,
    icon: element,
  },
));

MapFilledIcon.displayName = 'MapFilledIcon';

export default MapFilledIcon;
